module.exports = __webpack_public_path__ + "static/media/logo-one.18c1d0ad.svg";